import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useDropzone } from 'react-dropzone';

import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import HomeIcon from '@mui/icons-material/Home';
import { useMaterialReactTable } from 'material-react-table';
import {
    
    MaterialReactTable,

} from 'material-react-table';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Rating from '@mui/material/Rating';
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import SpeedIcon from "@mui/icons-material/Speed"
import SettingsIcon from '@mui/icons-material/Settings';
import moment from 'moment';
import Chip from '@mui/material/Chip';

import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Drawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { useParams } from "react-router-dom";
import GarageIcon from '@mui/icons-material/Garage';
import CarRentalIcon from '@mui/icons-material/CarRental';

import {
    Tooltip
} from '@mui/material';
import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import LocalParkingIcon from '@mui/icons-material/LocalParking';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import Rodape from '../../../../../../components/Rodape';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import CadastrarAtribuicao from './cadastrarAtribuicao';

import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';


import { Box, Card, CardContent } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BuildIcon from "@mui/icons-material/Build";
import WarningIcon from "@mui/icons-material/Warning";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CadastrarCombustivel from './cadastrarCombustivel';

const drawerWidth = 240;

const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'white',
        borderColor: 'blue',
    },
}));



export default function Atribuicoes({ veiculo, atribuicoes, listarAtribuicoes }) {

    const [loading, setLoading] = useState(true);


    const [atualizarAtribuicao, setAtualizarAtribuicao] = useState(false);
    const [atribuicaoAtualizar, setAtribuicaoAtualizar] = useState(null);

    const openAtualizarAtribuicao = (atr) => {
        setAtribuicaoAtualizar(atr);

        setAtualizarAtribuicao(true);
    }


    const closeAtualizarAtribuicao = () => {
        //setOcorrenciaAtualizar(null);

        setAtualizarAtribuicao(false);
        listarAtribuicoes();
    }


    const [novoCombustivel, setNovoCombustivel] = useState(false);

    const openNovoCombustivel = (atr) => {
        setAtribuicaoAtualizar(atr);

        setNovoCombustivel(true);

    }



    const closeNovoCombustivel = () => {
        setNovoCombustivel(false);
        listarAtribuicoes();
    }


    const columns = useMemo(
        () => [



            {
                accessorKey: 'id_atribuicao', //normal accessorKey
                header: 'ID',
                size: 60,
            },
            {
                accessorKey: 'status',
                header: 'Status (T)',
                size: 150,
                Cell: ({ row }) => {
                    let bgColor = '';
                    let texto = '';

                    switch (row.original.status) {
                        case 0:
                            bgColor = '#4CAF50'; // verde
                            texto = 'EM ANDAMENTO';
                            break;
                        case 10:
                            bgColor = '#2196F3'; // azul
                            texto = 'ENCERRADO';
                            break;
                        default:
                            texto = '';
                            bgColor = 'transparent';
                    }

                    return (
                        <div
                            style={{
                                backgroundColor: bgColor,
                                color: row.original.status === 2 ? '#000' : '#fff', // preto no amarelo
                                padding: '4px 8px',
                                borderRadius: '4px',
                                textAlign: 'center',
                                fontWeight: 'bold'
                            }}
                        >
                            {texto}
                        </div>
                    );
                }
            },
            {
                header: 'Data Retirada',
                size: 150,
                accessorKey: 'data_retirada', //normal accessorKey
                Cell: ({ row }) => {
                    const data = moment(row.original.data_retirada, "YYYY-MM-DD");
                    const dataFormatada = data.format("DD/MM/YYYY");
                    return dataFormatada + " " + row.original.hora_retirada;
                },
            },


            {
                header: 'Odómetro Inicial',
                size: 100,
                accessorKey: 'odometro_inicio',
            },

            {
                header: 'Combustível Inicial',
                size: 180,
                accessorKey: 'litros_inicio',
                Cell: ({ row }) => {
                    const litrosInicio = Number(row.original.litros_inicio || 0);
                    const capacidade = Number(veiculo?.capacidade_combustivel || 0);

                    const litrosReais = litrosInicio * (capacidade / 8);

                    return `${litrosReais.toFixed(2)} Litros`;
                }
            },

            {
                header: 'Responsável',
                id: 'responsavel',
                size: 350,
                accessorFn: row => {
                    return {
                        responsavel: row.responsavel,

                    };

                },
                Cell: ({ row }) => {
                    var colaborador = row.original.responsavel;
                    var texto = "Nome: " + colaborador.nome + " " + colaborador.sobrenome + " | " +
                        "CPF: " + colaborador.cpf;
                    return (
                        <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            {texto}
                        </span>
                    );
                }
            },


            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 100,
            },


            {
                header: 'Data Devolução',
                size: 150,
                accessorKey: 'data_devolucao', //normal accessorKey
                Cell: ({ row }) => {
                    const data = moment(row.original.data_devolucao, "YYYY-MM-DD");
                    const dataFormatada = data.format("DD/MM/YYYY");
                    return dataFormatada;
                },
            },
            {
                header: 'Hora Devolução',
                size: 150,
                accessorKey: 'hora_retirada',
            },

            {
                header: 'Odómetro Final',
                size: 150,
                accessorKey: 'odometro_fim',
            },

           
              {
                header: 'Combustível Final',
                size: 180,
                accessorKey: 'listros_fim',
                Cell: ({ row }) => {
                    const litrosInicio = Number(row.original.listros_fim || 0);
                    const capacidade = Number(veiculo?.capacidade_combustivel || 0);

                    const litrosReais = litrosInicio * (capacidade / 8);

                    return `${litrosReais.toFixed(2)} Litros`;
                }
            },

            {
                header: 'Criador',
                id: 'criado_por',
                size: 600,
                accessorFn: row => {
                    return {
                        criador: row.usuario_criador,
                        data: row.data_hora_criacao,

                    };

                },
                Cell: ({ renderedCellValue }) => {
                    var nome = renderedCellValue.criador.nome_amigavel;
                    const data = moment(renderedCellValue.data, "YYYY-MM-DD HH:mm:ss");
                    const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
                    return (
                        <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            adicionado por {nome} em {dataFormatada}
                        </span>
                    );
                }
            },


        ],
        [],
    );





    const columnsCombustivel = useMemo(
        () => [

            {
                accessorKey: 'id_combustivel', //normal accessorKey
                header: 'ID',
                size: 30,
                maxWidth: 30,
                id: 'id_combustivel',
            },
            {
                header: 'Data',
                size: 150,
                accessorKey: 'data', //normal accessorKey
                Cell: ({ row }) => {
                    const data = moment(row.original.data, "YYYY-MM-DD");
                    const dataFormatada = data.format("DD/MM/YYYY");
                    return dataFormatada + " " + row.original.hora;
                },
            },

            {
                header: 'Odómetro Inicial',
                size: 120,
                accessorKey: 'odometro',
                Footer: ({ table }) => {
                    const odometros = table
                        .getRowModel()
                        .rows
                        .map(row => parseFloat(row.original.odometro) || 0);

                    if (odometros.length === 0) return null;

                    const min = Math.min(...odometros);
                    const max = Math.max(...odometros);
                    const totalPercorrido = max - min;

                    return (
                        <strong>
                            Total: {totalPercorrido} km percorridos
                        </strong>
                    );
                },
            },

           
             {
                header: 'Combustível Inicial',
                size: 120,
                accessorKey: 'litros',
                Cell: ({ row }) => {
                    const litrosInicio = Number(row.original.litros || 0);
                    const capacidade = Number(veiculo?.capacidade_combustivel || 0);

                    const litrosReais = litrosInicio * (capacidade / 8);

                    return `${litrosReais.toFixed(2)} Litros`;
                }
            },

            {
                accessorKey: 'tipo_combustivel',
                header: 'Tipo Combustivél',
                size: 150,
                Cell: ({ row }) => {
                    switch (row.original.tipo_combustivel) {
                        case 0: return 'GASOLINA COMUM';
                        case 10: return 'GASOLINA ADITIVADA';
                        case 20: return 'ETANOL';
                        case 30: return 'DIESEL S10';
                        case 40: return 'DIESEL S500';
                        case 50: return 'GNV';

                        default: return '';
                    }
                },
            },
            {
                header: 'Valor por Litro',
                size: 120,
                accessorKey: 'valor_quantidade',
                Cell: ({ cell }) => {
                    const valor = cell.getValue();
                    return valor !== null && valor !== undefined
                        ? Number(valor).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : "";
                },
            },
            {
                header: 'Quantidade',
                size: 120,
                accessorKey: 'quantidade',
                Footer: ({ table }) => {
                    // pega todas as linhas da tabela
                    const total = table
                        .getRowModel()
                        .rows.reduce((sum, row) => sum + (parseFloat(row.original.quantidade) || 0), 0);

                    return (
                        <strong>
                            Total: {total} Litros abastecidos
                        </strong>
                    );
                },
            },
            {
                header: 'Valor Total',
                size: 120,
                accessorKey: 'valor_total',
                Cell: ({ cell }) => {
                    const valor = cell.getValue();
                    return valor !== null && valor !== undefined
                        ? Number(valor).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : "";
                },
                Footer: ({ table }) => {
                    // pega todas as linhas da tabela
                    const total = table
                        .getRowModel()
                        .rows.reduce((sum, row) => sum + (parseFloat(row.original.valor_total) || 0), 0);

                    return (
                        <strong>
                            Valor Total: {Number(total).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL"
                            })}
                        </strong>
                    );
                },
            }



        ],
        [],
    );


    const table = useMaterialReactTable({
        columns: columns,
        data: atribuicoes,
        enableGlobalFilterModes: true,
        enablePagination: true,
        enableRowActions: true,
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_atribuicao,
        enableTopToolbar: true,
        enableBottomToolbar: true,
        enableColumnFilters: true,
        enableColumnActions: false,
        sortable: true,
        enableSorting: true,
        enableRowSelection: false,
        enableColumnFilterModes: true,
        enableExpandAll: true,
        enableColumnPinning: true,
        enableColumnResizing: true,
        initialState: {
            pagination: { pageSize: 100, pageIndex: 0 },
            showGlobalFilter: true,
            density: 'compact',
        },
        muiPaginationProps: {
            rowsPerPageOptions: [100, 500, 1000],
            variant: 'outlined',
        },
        enableFullScreenToggle: true,
        renderDetailPanel: ({ row }) => (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-around',
                    left: '30px',
                    maxWidth: '1000px',
                    position: 'sticky',
                    width: '100%',
                }}
            />
        ),
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                <Tooltip title="Gerenciar">
                    <IconButton
                        color="primary"
                        onClick={(e) => openAtualizarAtribuicao(row.original)}
                    >

                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),

        renderDetailPanel: ({ row }) => (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                item xs={12}
            >
                {/* Botão alinhado à direita */}
                <Grid
                    container
                    item xs={6}
                    justifyContent="flex-end"
                    alignItems="center"

                >
                    <Button
                        style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={(e) => openNovoCombustivel(row.original)}
                    >
                        Inserir Abastecimento
                    </Button>
                </Grid>
                <Grid
                    container
                    item xs={6}


                >
                </Grid>

                {/* Tabela centralizada */}
                <Grid
                    container
                    item xs={12}
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <MaterialReactTable
                        columns={columnsCombustivel}
                        data={row.original.combustiveis}
                        enableBottomToolbar={false}
                        enableTopToolbar={false}
                        enableGlobalFilterModes={false}
                        enablePagination={false}
                        enableRowActions={true}
                        enableColumnResizing={true}
                        getRowId={(row) => row.id_combustivel}

                        muiTableContainerProps={{ sx: { maxHeight: '600px', width: '100%' } }} // controla largura
                        muiTableBodyRowProps={{
                            sx: { height: 40, color: 'black' },
                        }}


                        enableFullScreenToggle={true}
                    />
                </Grid>

                <Grid
                    container
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <Card
                        sx={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            padding: "12px",
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                            width: "100%",
                            maxWidth: 400, // limite de largura para não ficar esticado demais
                        }}
                    >
                        <CardContent sx={{ padding: "8px !important" }}>
                            <Grid container spacing={2} alignItems="center">
                                {/* Consumo */}
                                <Grid item xs={12} sm={6} display="flex" alignItems="center">
                                    <LocalGasStationIcon sx={{ color: "#1976d2", marginRight: "8px" }} />
                                    <Typography variant="body1" color="text.primary">
                                        <strong>Consumo:</strong> {row.original.consumo} L
                                    </Typography>
                                </Grid>

                                {/* Autonomia */}
                                <Grid item xs={12} sm={6} display="flex" alignItems="center">
                                    <SpeedIcon sx={{ color: "green", marginRight: "8px" }} />
                                    <Typography variant="body1" color="text.primary">
                                        <strong>Autonomia:</strong> {row.original.autonomia?.toFixed(2)} km/l
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        ),


    });

    return (
        <>
            <MaterialReactTable
                table={table}
            />
            <Dialog open={atualizarAtribuicao} onClose={closeAtualizarAtribuicao} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarAtribuicao
                        flag={1}
                        veiculo={veiculo}
                        closeAtualizarAtribuicao={closeAtualizarAtribuicao}
                        atribuicaoAtualizar={atribuicaoAtualizar}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={novoCombustivel} onClose={closeNovoCombustivel} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarCombustivel
                        flag={0}
                        veiculo={veiculo}
                        atribuicao={atribuicaoAtualizar}
                        closeNovoCombustivel={closeNovoCombustivel}
                    />
                </DialogContent>
            </Dialog>


        </>
    );
}



